import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMultiPromptTemplates,
  BackendQueryCustomerMultiPromptTemplatesArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_TEMPLATES } from './schema';

const QUERY = gql`
  query QueryCustomerMultiPromptTemplates($customerId: ID!, $workspaceId: ID) {
    customerMultiPromptTemplates(customerId: $customerId, workspaceId: $workspaceId) {
      ...CustomerMultiPromptTemplates
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATES}
`;

type Variables = Pick<BackendQueryCustomerMultiPromptTemplatesArgs, 'customerId' | 'workspaceId'>;
type Result = BackendCustomerMultiPromptTemplates;

export const queryCustomerMultiPromptTemplates = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data)?.templates;
};
